(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
  class AnnouncementRotator extends HTMLElement {
    connectedCallback() {
      this.messages = Array.from(this.querySelectorAll('[data-announcement]'));
      if (this.messages.length < 2 || this.started) return;
      this.started = true;

      this.live = this.querySelector('[data-announcement-messages]');
      this.index = Math.max(0, this.messages.findIndex((message) => message.classList.contains('is-active')));
      this.delay = (parseInt(this.dataset.interval, 10) || 8) * 1000;
      this.autoplay =
        this.hasAttribute('data-autoplay') && !window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      this.querySelector('[data-announcement-prev]').addEventListener('click', () => this.step(-1));
      this.querySelector('[data-announcement-next]').addEventListener('click', () => this.step(1));
      this.addEventListener('pointerenter', () => this.pause());
      this.addEventListener('pointerleave', () => this.play());
      this.addEventListener('focusin', () => this.pause());
      this.addEventListener('focusout', (event) => {
        if (!this.contains(event.relatedTarget)) this.play();
      });

      this.onBlockSelect = (event) => {
        const index = this.messages.indexOf(event.target);
        if (index === -1) return;
        this.stopped = true;
        this.pause();
        this.show(index);
      };
      document.addEventListener('shopify:block:select', this.onBlockSelect);

      this.play();
    }

    disconnectedCallback() {
      this.pause();
      if (this.onBlockSelect) document.removeEventListener('shopify:block:select', this.onBlockSelect);
      this.started = false;
    }

    show(index) {
      this.index = (index + this.messages.length) % this.messages.length;
      this.live.setAttribute('data-rotated', '');
      this.messages.forEach((message, i) => {
        const active = i === this.index;
        message.classList.toggle('is-active', active);
        if (active) {
          message.removeAttribute('aria-hidden');
        } else {
          message.setAttribute('aria-hidden', 'true');
        }
      });
    }

    // A button press ends the rotation and shows the next message. Rotated messages are
    // not announced; the live region turns on first so the chosen one is.
    step(direction) {
      this.stopped = true;
      this.pause();
      this.live.setAttribute('aria-live', 'polite');
      requestAnimationFrame(() => this.show(this.index + direction));
    }

    play() {
      if (!this.autoplay || this.stopped) return;
      this.pause();
      this.timer = setInterval(() => this.show(this.index + 1), this.delay);
    }

    pause() {
      clearInterval(this.timer);
    }
  }

  if (!customElements.get('announcement-rotator')) customElements.define('announcement-rotator', AnnouncementRotator);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  /*
    Sticky header. Ride's behavior (none, on scroll up, always) plus the v2 compact state:
    once the page has scrolled past COMPACT_AT on desktop, the section gets the `compact`
    class and its sticky top moves up by the logo row, so only the rail row shows. The
    header keeps its height, so nothing below it moves.
  */
  class StickyHeader extends HTMLElement {
    static COMPACT_AT = 150;

    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.compactOnScroll = this.hasAttribute('data-compact');
      this.desktopQuery = window.matchMedia('(min-width: 1140px)');
      this.headerBounds = {};

      this.setHeaderHeight();
      this.resizeObserver = new ResizeObserver(() => this.setHeaderHeight());
      this.resizeObserver.observe(this.header);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.onBreakpointChange = () => this.updateCompact();
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, { passive: true });
      this.desktopQuery.addEventListener('change', this.onBreakpointChange);

      this.createObserver();
      this.updateCompact();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
      this.setVisibleHeight();
    }

    // --header-visible-height: what stays on screen once the header sticks (the rail row when
    // compact), for things that stick below it.
    setVisibleHeight() {
      const row1 = this.querySelector('.header__row-1');
      const compact =
        this.header.classList.contains('compact') && this.header.classList.contains('shopify-section-header-sticky');
      const hidden = compact && row1 ? row1.offsetHeight : 0;
      document.documentElement.style.setProperty('--header-visible-height', `${this.header.offsetHeight - hidden}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
      this.desktopQuery.removeEventListener('change', this.onBreakpointChange);
      this.resizeObserver.disconnect();
      this.header.classList.remove('compact');
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    updateCompact(scrollTop = window.scrollY) {
      const compact = this.compactOnScroll && this.desktopQuery.matches && scrollTop > StickyHeader.COMPACT_AT;
      if (compact === this.header.classList.contains('compact')) return;

      this.header.classList.toggle('compact', compact);
      this.setVisibleHeight();
      this.closeMenuDisclosure();
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      this.updateCompact(scrollTop);

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.megaMenu = this.megaMenu || this.querySelector('header-mega');
      if (this.megaMenu && typeof this.megaMenu.close === 'function') this.megaMenu.close();
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (this.searchModal) this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
